import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=18fed61e&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=18fed61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fed61e",
  null
  
)

export default component.exports